import './Loading.css'

const Loading = () => {
    return (
        <div className='LoadingContainer'>
            <h2>Loading...</h2>
            <img src='../media/loading.gif' className='ImageLoading' alt='loading' />
        </div>
    )
}

export default Loading